import React, { useState, useEffect, useMemo } from "react";
import {
  Check,
  User,
  FileText,
  Upload,
  CheckCircle,
  Info,
  User2,
  Building2Icon,
  ShieldAlert,
} from "lucide-react";
import {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
} from "../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { MdDashboard } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { removeToken } from "../../utils/tokenUtils";
import { logout } from "../../Services/authService";
import { RiLogoutBoxLine } from "react-icons/ri";
import FileUploadBox from "./FileUploadBox";
import DigitalKycAadharSignUp from "../DashboardMenu/DigitalKycAadharSignUp";
import DigitalKycEmailSignUp from "../DashboardMenu/DigitalKycEmailSignUp";
import DigitalKycMobileSignUp from "../DashboardMenu/DigitalKycMobileSignUp";
import {
  fetchCompanyTypes,
  fetchDocumentList,
  submitBusinessDetails,
  companyCinVerifySignUp,
  submitSignatoryDetails,
  uploadDocument,
} from "../../Services/authService";
import {
  aadharverifySignUpService,
  fetchProfile,
  verifyEmailSignUp,
  verifyMobileSignUp,
  verifyPanSignUpService,
  verifyCompanyPanSignUpService,
  UserTypeCheckService,
} from "../../Services/profile/profileservice";
import Loader from "../../Loader";

export default function CompleteProfile() {
  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setShowModal] = useState(false);
  const [isModalOpenEmail, setModalOpenEmail] = useState(false);
  const [isModalOpenMobile, setShowModalMobile] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [isPanVerify, setIsPanVerify] = useState(false);
  const [isCompanyPanVerfiy, setIsCompanyPanVerify] = useState(false);
  const [isAadharVerify, setIsAadharVerify] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);
  const [isEmailVerify, setIsEmailVerify] = useState(false);
  const [clientID, setClientID] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [pan, setPan] = useState("");
  const [aadhar, setAadhar] = useState("");
  const [companyTypes, setCompanyTypes] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [finalDetails, setFinalDetails] = useState({});
  const [cinData, setCinData] = useState({});
  const [panData, setPanData] = useState({});
  const [companyPanData, setCompanyPanData] = useState({});
  const [skipBusiness, setSkipBusiness] = useState(false);

  const toggleModal = () => setShowModal(false);
  const toggleModalMobile = () => setShowModalMobile(false);
  const toggleModalEmail = () => setModalOpenEmail(false);
  const [openTypeModal, setOpenTypeModal] = useState(true);
  const [userType, setUserType] = useState(null);
  const [cinVerifyResponse, setCinVerifyResponse] = useState(null);
  const navigate = useNavigate();

  // Business Details Form
  const [formData, setFormData] = useState({
    gstAvailable: "yes",
    gstNo: "",
    cinNo: "",
    businessName: "",
    companyPan: "",
    protocol: "https",
    domain: "",
    websiteUrl: "",
    businessClass: "",
    lineOfBusiness: "",
    businessDescription: "",
  });

  // Signatory Details Form
  const [signatoryData, setSignatoryData] = useState({
    name: "",
    aadharNo: "",
    panNo: "",
    phone: "",
    email: "",
    landmarkAddress: "",
    dob: "",
    gender: "",
    aadhar_response: null,
    pan_response: null,
  });

  // Document Upload Form
  const [DoctformData, setDoctFormData] = useState({
    aadharUpload: null,
    panUpload: null,
    gstUpload: null,
    coiUpload: null,
    companypanUpload: null,
    moaUpload: null,
    aoaUpload: null,
    photographUpload: null,
    partnershipdeedUpload: null,
    UserCompanyPanUpload: null,
  });

  useEffect(() => {
    const loadCompanyTypes = async () => {
      try {
        const response = await fetchCompanyTypes();
        const typesArray = Array.isArray(response.data) ? response.data : [];
        setCompanyTypes(typesArray);
      } catch (error) {
        console.error("Failed to load company types:", error);
        setCompanyTypes([]);
      }
    };
    loadCompanyTypes();
  }, []);

  const formatAadhar = (value) => {
    if (!value) return "";

    const digits = value.replace(/\D/g, ""); // only numbers
    return digits.slice(0, 12).replace(/(\d{4})(?=\d)/g, "$1-"); // add dash after every 4 digits
  };

  useEffect(() => {
    const loadDocumentList = async () => {
      try {
        const response = await fetchDocumentList();
        const docsArray = Array.isArray(response.data) ? response.data : [];

        // const filteredDocs = docsArray.filter((doc) => {
        //   // If kyc_applicable is null or empty → show for all
        //   if (!doc.kyc_applicable) return true;

        //   return doc.kyc_applicable === userType;
        // });

        const filteredDocs = docsArray.filter((doc) => {
          if (userType === "BUSINESS") return true;

          if (userType === "INDIVIDUAL") {
            return !doc.kyc_applicable || doc.kyc_applicable === "INDIVIDUAL";
          }
          return false;
        });

        const formattedDocs = filteredDocs.map((doc) => ({
          id: doc.id,
          name: `${doc.name.toLowerCase().replace(/\s+/g, "")}Upload`,
          label: doc.name,
          description: `Upload your ${doc.name}`,
          is_required: Boolean(doc.is_required),
          uploaded: doc.is_uploaded || false,
          group: doc.group,
        }));

        setDocumentList(formattedDocs);

        // Prefill already uploaded docs
        const uploadedDocs = {};
        formattedDocs.forEach((d) => {
          uploadedDocs[d.name] = d.uploaded
            ? { name: "Uploaded Document" }
            : null;
        });

        setDoctFormData((prev) => ({
          ...prev,
          ...uploadedDocs,
        }));
      } catch (error) {
        console.error("Failed to load document list:", error);
        setDocumentList([]);
      }
    };

    loadDocumentList();
  }, [userType]);

  const validateRequiredDocuments = () => {
    const missingDocs = documentList.filter((doc) => {
      // Check if document is required
      if (!doc.is_required) return false;

      // Check if it's uploaded in formData OR in uploadedDocs
      const isInFormData =
        DoctformData[doc.name] && DoctformData[doc.name] !== null;
      const isInUploadedList = uploadedDocs.find(
        (d) => d.document_id === doc.id,
      );

      return !isInFormData && !isInUploadedList;
    });

    if (missingDocs.length > 0) {
      const missingNames = missingDocs.map((d) => d.label).join(", ");
      showErrorToast(`Please upload required documents: ${missingNames}`);
      return false;
    }

    return true;
  };

  //  Company CIN Verify Handler (Fixed)
  const handleCinVerify = async (cinValue) => {
    if (!cinValue || cinValue.length < 21) {
      showErrorToast("Please enter a valid 21-character CIN before verifying.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await companyCinVerifySignUp({
        payload: { company_cin: cinValue },
      });

      if (
        response?.status?.code === 200 ||
        response?.data?.status?.code === 200
      ) {
        const companyName =
          response?.data?.company_name ?? response?.data?.data?.company_name;

        if (
          companyName &&
          companyName !== "undefined" &&
          companyName !== "null"
        ) {
          localStorage.setItem("business_name", companyName);
        }

        showSuccessToast(response?.message || response?.data?.message);
        setCinVerifyResponse(response);
      } else {
        showErrorToast(response?.message || response?.data?.message);
      }

      //  Handle both success and message cases safely
      const data = response?.data?.data || response?.data;
      const message =
        response?.data?.message ||
        response?.message ||
        "CIN Verified Successfully!";

      // check 400 status
      if (response?.status === 400) {
        showErrorToast(message || "CIN verification failed.");
        setIsLoading(false);
        return;
      }

      if (
        data &&
        (data?.company_name || data?.company_master_data?.company_llp_name)
      ) {
        // Save CIN data in state
        setCinData(data || data?.data || "");

        // Update business name instantly
        setFormData((prev) => ({
          ...prev,
          businessName:
            data?.company_name ||
            data?.company_master_data?.company_llp_name ||
            prev?.businessName,
        }));
        showSuccessToast(message);
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "CIN verification failed. Please try again.";

      showErrorToast(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  //  Auto-update business name when CIN data arrives
  useEffect(() => {
    if (cinData?.company_name) {
      setFormData((prev) => ({
        ...prev,
        businessName: cinData?.company_name,
      }));
    }
  }, [cinData]);

  //  Reset CIN data when CIN field changes
  useEffect(() => {
    if (!formData?.cinNo || formData?.cinNo?.length < 21) {
      setCinData(null);
    }
  }, [formData?.cinNo]);

  const steps = [
    { id: 0, title: "Business Details", icon: User },
    { id: 1, title: "Signatory Details", icon: FileText },
    { id: 2, title: "Upload Documents", icon: Upload },
    { id: 3, title: "Submit", icon: CheckCircle },
  ];

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSignatoryInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "aadharNo") {
      setSignatoryData((prev) => ({
        ...prev,
        [name]: value.replace(/\D/g, "").slice(0, 12),
      }));
    } else if (name === "panNo") {
      setSignatoryData((prev) => ({
        ...prev,
        [name]: value.toUpperCase(),
      }));
    } else {
      setSignatoryData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    console.log(signatoryData);
  }, [signatoryData]);

  const handleDocumentInputChange = async (e) => {
    const { name, files } = e.target;
    if (!files || !files[0]) return;

    const file = files[0];
    setDoctFormData((prev) => ({ ...prev, [name]: file }));

    const doc = documentList.find((d) => d.name === name);
    if (!doc) return;

    const formData = new FormData();
    formData.append("document_id", doc.id);
    formData.append("file", file);

    try {
      const res = await uploadDocument(formData);
      if (res?.status?.code === 200) {
        setDoctFormData((prev) => ({
          ...prev,
          [name]: file,
        }));
        showSuccessToast(`${doc.label} uploaded successfully!`);
      } else {
        showErrorToast(res?.status?.message || "Upload failed!");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      showErrorToast(error?.response?.data?.message || "Upload failed!");
    }
  };

  useEffect(() => {
    if (isLoading) {
      // while loading → NEVER open modal
      setOpenTypeModal(false);
      return;
    }

    if (profileData?.type) {
      setUserType(profileData?.type);
      // console.log("type",userType);

      if (profileData?.type === "INDIVIDUAL") {
        setSkipBusiness(true);
        // setCurrentStep(1);
      } else {
        setSkipBusiness(false);
      }

      setOpenTypeModal(false);
    } else {
      // Only open modal AFTER loading finishes
      setOpenTypeModal(true);
    }
  }, [profileData, isLoading]);

  useEffect(() => {
    if (skipBusiness) {
      setCurrentStep(1);
    }
  }, [skipBusiness]);

  const handleUserTypeSelect = async () => {
    if (!userType) {
      showWarningToast("Please select type!");
      return;
    }

    try {
      const res = await UserTypeCheckService({ type: userType });
      const serverType = res?.data?.type;

      setUserType(serverType);

      setProfileData((prev) => ({
        ...prev,
        type: serverType, // ✅ FIX: update profileData
      }));

      if (serverType === "INDIVIDUAL") {
        setSkipBusiness(true);
      } else {
        setSkipBusiness(false);
      }

      setOpenTypeModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  const validateStep = () => {
    const validatePAN = (pan) =>
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan?.toUpperCase());

    //  STEP 0: Business Details
    if (currentStep === 0) {
      // ⭐ Skip validation of Business Step
      if (skipBusiness) return true;

      const {
        lineOfBusiness,
        businessDescription,
        cinNo,
        gstNo,
        gstAvailable,
        companyPan,
      } = formData;

      let missing = [];

      if (!lineOfBusiness) missing.push("Line of Business");
      if (!businessDescription) missing.push("Business Description");
      if (!cinNo) missing.push("CIN/Registration No");
      if (!companyPan) missing.push("Company PAN");

      // GST VALIDATION
      if (gstAvailable === "yes") {
        const gstRegex =
          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

        if (!gstNo) {
          missing.push("GST No");
        } else if (gstNo.length !== 15) {
          missing.push("GST No must be 15 Alphanumeric long");
        } else if (!gstRegex.test(gstNo.toUpperCase())) {
          missing.push("GST No format is invalid");
        }
      }

      // ⛔ Missing field error
      if (missing.length > 0) {
        showErrorToast(
          `Please fill in the following fields: ${missing.join(", ")}`,
        );
        return false;
      }

      // ⛔ PAN Format Check
      if (companyPan && !validatePAN(companyPan)) {
        showErrorToast("Invalid Company PAN format.");
        return false;
      }
    }

    // ✅ STEP 1: Signatory Details
    if (currentStep === 1) {
      const { aadharNo, panNo } = signatoryData;
      let missing = [];

      if (!aadharNo) missing.push("Aadhar No");
      if (!panNo) missing.push("PAN No");

      if (missing.length > 0) {
        showErrorToast(`Please fill required fields: ${missing.join(", ")}`);
        return false;
      }

      // ⛔ FORMAT CHECK
      if (panNo && !validatePAN(panNo)) {
        showErrorToast("Invalid PAN No format.");
        return false;
      }
    }

    // STEP 3 always true
    if (currentStep === 3) return true;

    return true;
  };

  // ✅ FIX 3: handlePrev - Don't go to step 0 for INDIVIDUAL
  const handlePrev = () => {
    const minStep = profileData?.type === "INDIVIDUAL" || skipBusiness ? 1 : 0;
    if (currentStep > minStep) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  // handle Next Step
  const handleNext = async () => {
    // if (!validateStep()) return;

    try {
      setIsLoading(true); //  Start loader at the beginning

      // ---------------- STEP 1 : BUSINESS DETAILS ----------------
      if (currentStep === 0) {
        // ⭐ Skip Step 0 if INDIVIDUAL business type
        if (skipBusiness) {
          setCurrentStep(1);
          return;
        }

        const payload = {
          company_gst_no:
            formData.gstAvailable === "yes" ? formData.gstNo : null,
          company_cin: formData.cinNo,
          company_name: formData.businessName,
          pan: formData.companyPan,
          company_domain: formData.websiteUrl,
          company_type_id: formData.businessClass,
          line_of_business: formData.lineOfBusiness,
          business_description: formData.businessDescription,
        };

        const response = await submitBusinessDetails(payload);
        showSuccessToast(
          response?.message ||
            response?.data?.message ||
            "Business details submitted successfully!",
        );
        setCurrentStep(1);
        return;
      }

      // ---------------- STEP 2 : SIGNATORY DETAILS ----------------
      if (currentStep === 1) {
        const flattenedAddress = signatoryData.aadhar_response?.address
          ? `${signatoryData?.aadhar_response.address?.house || ""}, ${signatoryData?.aadhar_response?.address?.street || ""}, ${signatoryData?.aadhar_response?.address.vtc || ""}, ${signatoryData?.aadhar_response?.address?.subdist || ""}, ${signatoryData?.aadhar_response?.address?.dist || ""}, ${signatoryData?.aadhar_response?.address?.state || ""}, ${signatoryData?.aadhar_response?.address?.country || ""}`
          : signatoryData?.landmarkAddress || "";

        const payload = {
          name:
            signatoryData.name ||
            signatoryData.aadhar_response?.full_name ||
            "",
          aadhar_number: signatoryData.aadharNo,
          pan_number: signatoryData.panNo,
          mobile_number: signatoryData.phone,
          email_address: signatoryData.email,
          landmark_address:
            signatoryData.landmarkAddress ||
            signatoryData.aadhar_response?.address?.landmark ||
            "",
          address: flattenedAddress || "",
          aadhar_response: signatoryData.aadhar_response,
          pan_response: signatoryData.pan_response,
        };

        const response = await submitSignatoryDetails(payload);
        setFinalDetails(
          response?.data?.user || response?.data?.data?.user || {},
        );
        console.log("dataSign", response);
        console.log("step", steps);
        showSuccessToast(
          response?.message ||
            response?.data?.message ||
            "Signatory details submitted successfully!",
        );

        setCurrentStep(2);
        return;
      }

      // ---------------- STEP 3 : DOCUMENTS ----------------
      if (currentStep === 2) {
        const requiredDocs = filteredDocs.filter((doc) => doc.is_required);

        // ✅ Combine both uploaded documents and newly selected ones
        const allUploadedDocIds = new Set([
          ...uploadedDocs.map((d) => d.document_id),
          ...Object.keys(DoctformData)
            .map((key) => {
              const found = documentList.find((d) => d.name === key);
              return found ? found.id : null;
            })
            .filter(Boolean),
        ]);

        // ✅ Check which required docs are still missing
        const missingDocs = requiredDocs.filter(
          (doc) => !allUploadedDocIds.has(doc.id),
        );

        if (missingDocs.length > 0) {
          showErrorToast(
            `Please upload required documents: ${missingDocs
              .map((d) => d.label)
              .join(", ")}`,
          );
          return;
        }

        //  Everything uploaded — success!
        showSuccessToast("All documents uploaded successfully!");
        setCurrentStep(currentStep + 1);
        return;
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong! Please try again.";
      showErrorToast(errorMsg);
      console.error("API Error:", error);
    } finally {
      setIsLoading(false); //  Stop loader no matter success or error
    }
  };
  // ENd

  useEffect(() => {
    console.log("current step", currentStep);
    
  }, [currentStep])

  // Submit Button
  const handleSubmit = () => {
    if (!validateStep()) return;
    showSuccessToast("Registration completed successfully!");
    navigate("/Dashboard");
    setCurrentStep(0);
  };

  const filteredDocs = useMemo(() => {
    return documentList;
  }, [documentList]);

  const validatePAN = (pan) =>
    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan?.toUpperCase());

  const isBusinessPAN = (pan) => {
    const fourth = pan?.toUpperCase()?.charAt(3);
    return ["C", "F", "A", "T", "B", "G", "L", "J", "H"].includes(fourth);
  };

  // Validate Pan No
  async function validateCompanyPan() {
    try {
      const pan = formData?.companyPan;

      //  Format check
      if (!validatePAN(pan)) {
        showErrorToast("Invalid Company PAN format.");
        return;
      }

      //  Must be Business PAN
      if (!isBusinessPAN(pan)) {
        showErrorToast(
          "This PAN looks like an Individual PAN. Enter a valid Business PAN.",
        );
        return;
      }

      // ------------------ API CALL ------------------
      setIsLoading(true);
      setIsCompanyPanVerify(true);

      const response = await verifyCompanyPanSignUpService({
        pan: pan,
      });

      if (response?.status === 400) {
        showErrorToast(
          response?.status?.message || "PAN number already exists.",
        );
        return;
      }

      if (response?.status === 422) {
        showErrorToast(
          response?.data?.details?.message || "Company PAN is invalid",
        );
        return;
      }

      if (response?.status?.code === 200) {
        showSuccessToast(
          response.status.message || "Company PAN Verified Successfully",
        );
        setCompanyPanData(response.data || []);
        getProfile();
        return;
      }

      showWarningToast("Unexpected response status");
    } catch (error) {
      showWarningToast("Failed to verify Company PAN");
      console.error("Error during Company PAN verification:", error);
    } finally {
      setIsCompanyPanVerify(false);
      setIsLoading(false);
    }
  }
  // ENd

  const isIndividualPAN = (pan) => pan?.toUpperCase()?.charAt(3) === "P";

  // Validate Pan No
  async function validatePan() {
    try {
      const pan = signatoryData?.panNo;

      //  Format check
      if (!validatePAN(pan)) {
        showErrorToast("Invalid PAN format.");
        return;
      }

      //  Must be INDIVIDUAL PAN
      if (!isIndividualPAN(pan)) {
        showErrorToast(
          "This PAN looks like a Business PAN. Enter an Individual PAN.",
        );
        return;
      }

      // ------------------ API CALL ------------------
      setIsLoading(true);
      setIsPanVerify(true);

      const response = await verifyPanSignUpService({ pan_number: pan });

      if (response?.status === 400) {
        showErrorToast(
          response?.status?.message || "PAN number already exists.",
        );
        return;
      }

      if (response?.status === 422) {
        showErrorToast(response?.data?.details?.message || "PAN is invalid");
        return;
      }

      if (response?.status?.code === 200) {
        showSuccessToast(
          response.status.message || "PAN Verified Successfully",
        );
        setPanData(response.data || []);
        getProfile();
        return;
      }

      showWarningToast("Unexpected response status");
    } catch (error) {
      showWarningToast("Failed to verify PAN");
      console.error("Error during PAN verification:", error);
    } finally {
      setIsPanVerify(false);
      setIsLoading(false);
    }
  }

  // ENd

  // Aadhar Validation
  async function validateAadhar() {
    try {
      setIsLoading(true);

      const response = await aadharverifySignUpService({
        aadhar_number: signatoryData?.aadharNo,
      });

      const statusCode = response?.status?.code || response?.status;

      if (statusCode === 400) {
        showErrorToast(response?.message || "Aadhar number already exists.");
        return;
      }

      if (statusCode === 422) {
        showErrorToast("Invalid Aadhaar Number");
        return;
      }

      if (statusCode === 500) {
        showErrorToast("Server error. Please try again later.");
        return;
      }

      // ✅ If Aadhaar is valid, open OTP Modal
      if (statusCode === 200) {
        showSuccessToast(response?.status?.message || "OTP sent successfully!");
        setClientID(response?.data?.data?.client_id || "");
        setShowModal(true);
        getProfile();
        return;
      }

      showWarningToast("Unexpected response from server");
    } catch (error) {
      showErrorToast("Failed to verify Aadhaar");
      console.error("Aadhar verification error:", error);
    } finally {
      setIsLoading(false);
      setIsLoading(false);
    }
  }
  // ENd

  // Validate Email ID
  async function validateEmail() {
    try {
      setIsLoading(true);
      setIsEmailVerify(true);
      const response = await verifyEmailSignUp();
      const statusCode =
        response?.status?.code || response?.code || response?.status;
      //  400 — Email already exists
      if (statusCode === 400) {
        const errorMessage = response?.message || "Email already exists.";
        showErrorToast(errorMessage);
        return;
      }

      //  422 — Invalid email format or verification failed
      if (statusCode === 422) {
        let serverMessage = "Invalid Email Address";

        try {
          // Sometimes the backend may return stringified JSON in message
          const parsed =
            typeof response.message === "string"
              ? JSON.parse(response.message)
              : null;
          serverMessage = parsed?.message || serverMessage;
        } catch (err) {
          console.error("422 parse error:", err);
        }

        showErrorToast(serverMessage);
        return;
      }

      //  500 — Server error
      if (statusCode === 500) {
        let serverErrorMessage = "Server error. Please try again later.";

        try {
          const parsedMessage =
            typeof response.message === "string"
              ? JSON.parse(response.message)
              : null;
          if (parsedMessage?.message)
            serverErrorMessage = parsedMessage.message;
        } catch (err) {
          console.error("500 parse error:", err);
        }

        showErrorToast(serverErrorMessage);
        return;
      }

      // ✅ 200 — Success
      if (statusCode === 200) {
        showSuccessToast(
          response?.status?.message || "Email verified successfully",
        );
        setIsEmailVerify(true);
        setIdentifier(response?.identifier);
        setModalOpenEmail(true);
        getProfile();
        return;
      }

      // ⚠️ Fallback
      // showWarningToast("Unexpected response from server");
    } catch (error) {
      console.error("Email verification error:", error);
      showErrorToast("Failed to verify Email");
    } finally {
      setIsEmailVerify(false);
      setIsLoading(false);
    }
  }
  // End

  // Validate Mobile
  async function validateMobile() {
    try {
      setIsLoading(true);
      setMobileVerified(true);
      const response = await verifyMobileSignUp({
        mobile_number: signatoryData?.phone,
      });
      const statusCode = response?.status?.code || response?.status;
      if (statusCode === 400) {
        const errorMessage =
          response?.message || "Mobile number already exists.";
        showErrorToast(errorMessage);
        return;
      }
      if (statusCode === 422) {
        let serverMessage = "Invalid mobile number";
        try {
          const parsed =
            typeof response.message === "string"
              ? JSON.parse(response.message)
              : null;
          serverMessage = parsed?.message || serverMessage;
        } catch (err) {
          console.error("422 parse error:", err);
        }
        showErrorToast(serverMessage);
        return;
      }

      // ❌ 500 — Server error
      if (statusCode === 500) {
        let serverErrorMessage = "Server error. Please try again later.";
        try {
          const parsed =
            typeof response.message === "string"
              ? JSON.parse(response.message)
              : null;
          if (parsed?.message) serverErrorMessage = parsed.message;
        } catch (err) {
          console.error("500 parse error:", err);
        }
        showErrorToast(serverErrorMessage);
        return;
      }

      // ✅ 200 — Success
      if (statusCode === 200) {
        showSuccessToast(
          response?.status?.message || "Mobile number verified successfully",
        );
        setMobileVerified(true);
        setIdentifier(response?.identifier);
        if (
          response?.status?.message !== "Mobile verification already completed."
        ) {
          setShowModalMobile(true);
        }
        if (
          response?.status?.message === "Mobile verification already completed."
        ) {
          setMobileVerified(true);
        }

        getProfile();
        return;
      }

      // ⚠️ fallback
      showWarningToast("Unexpected response from server");
    } catch (error) {
      console.error("Mobile verification error:", error);
      showWarningToast("Failed to verify mobile number");
    } finally {
      setMobileVerified(false);
      setIsLoading(false);
    }
  }
  // ENd

  // Fetch Profile Data that contain all Data
  const getProfile = async () => {
    setIsLoading(true);
    try {
      const response = await fetchProfile();
      const data = response.data;
      setMobile(data.mobile_number || "");
      setEmail(data.email_address || "");
      setAadhar(data.aadhar_number || "");
      setPan(data.pan_number || "");
      setProfileData(data ?? null);

      setSignatoryData((prev) => ({
        ...prev,
        name: data.name || prev.name || "",
        landmarkAddress: data.landmark_address || prev.landmarkAddress || "",
        aadharNo: data.aadhar_number || prev.aadharNo || "",
        panNo: data.pan_number || prev.panNo || "",
        phone: data.mobile_number || prev.phone || "",
        email: data.email_address || prev.email || "",
        dob: data.dob || prev.dob || "",
        gender: data.gender || prev.gender || "",
      }));

      //  Prefill company details directly into formData
      setFormData((prev) => ({
        ...prev,
        cinNo: data?.company_details?.company_cin || prev.cinNo || "",
        businessName:
          data?.company_details?.company_name || prev.businessName || "",
        companyPan: data?.company_details?.company_pan || prev.companyPan || "",
        lineOfBusiness:
          data?.company_details?.line_of_business || prev.lineOfBusiness || "",
        websiteUrl:
          data?.company_details?.company_domain || prev.websiteUrl || "",
        businessClass:
          data?.company_details?.company_type_id || prev.businessClass || "",
        businessDescription:
          data?.company_details?.business_description ||
          prev.businessDescription ||
          "",
        gstAvailable: data?.company_details?.company_gst_no
          ? "yes"
          : "no" || prev.gstAvailable || "",
        gstNo: data?.company_details?.company_gst_no || prev.gstNo || "",
      }));

      // Initialize empty uploads
      const updatedDocs = {
        photographUpload: null,
        aadharUpload: null,
        panUpload: null,
        gstUpload: null,
        cinUpload: null,
        companymoaUpload: null,
        companyaoaUpload: null,
        partnershipdeedUpload: null,
        UserCompanyPanUpload: null,
      };

      //  Update state finally
      setDoctFormData((prev) => ({
        ...prev,
        ...updatedDocs,
      }));

      // Verification flags
      // console.log("data",data)
      // console.log("data.pan_verified_at",data.pan_verified_at)
      // console.log("data",data.pan_verified_at)
      // console.log("data",data.mobile_verified_at)
      // console.log("data",data.mobile_verified_at)
      // console.log("data",data.email_verified_at)
      if (data?.aadhar_verified_at) setIsAadharVerify(true);
      if (data?.pan_verified_at) setIsPanVerify(true);
      if (data?.company_details?.company_pan_verified_at)
        setIsCompanyPanVerify(true);
      if (data?.mobile_verified_at) setMobileVerified(true);
      if (data?.email_verified_at) setIsEmailVerify(true);
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);
  // ENd

  useEffect(() => {
    if (profileData) {
      // setWalletBal(false);
    }
  }, [profileData]);

  const isCompanyPanAlreadyVerified =
    !!profileData?.company_details?.company_pan_verified_at;

  useEffect(() => {
    if (!profileData) return;

    const isIndividual = profileData?.type === "INDIVIDUAL";
    let step = 0;

    // ============================================================
    //  STEP 1 → SIGNATORY / COMPANY DETAILS
    // BUSINESS: requires company verification
    // INDIVIDUAL: SKIP company step → but do NOT force step=1 yet
    // ============================================================

    const isCompanyVerified =
      !isIndividual &&
      profileData?.company_details?.company_name &&
      profileData?.company_details?.company_pan_verified_at &&
      profileData?.company_details?.company_cin_verified_at &&
      profileData?.company_details?.business_description &&
      profileData?.company_details?.line_of_business &&
      profileData?.company_details?.company_type_id;

    if (!isIndividual && isCompanyVerified) {
      step = 1;
    }

    // ============================================================
    //  STEP 2 → BASIC VERIFICATION
    // ============================================================
    const allVerified =
      profileData?.mobile_verified_at &&
      // profileData?.aadhar_verified_at &&
      profileData?.pan_verified_at &&
      profileData?.email_verified_at;

    if (allVerified) {
      step = 2;
    }

    // ============================================================
    //  STEP 3 → DOCUMENTS COMPLETED (Doc ID = 8)
    // ============================================================
    const hasDoc8 = profileData?.kyc_documents?.some(
      (doc) => doc.document_id === 8,
    );

    if (allVerified && hasDoc8) {
      step = 3;
    }

    // ============================================================
    //  INDIVIDUAL → Ensure minimum step is 1
    // BUT DO NOT override higher completed steps
    // ============================================================
    if (isIndividual && step < 1) {
      step = 1;
    }

    // ============================================================
    //  Only forward step
    // ============================================================

    // console.log("isIndividual", isIndividual);
    // console.log("allVerified", allVerified);
    // console.log("hasDoc8", hasDoc8);
    // console.log("final auto step = ", step);

    setCurrentStep((prev) => Math.max(prev, step));
  }, [profileData]);

  const [uploadedDocs, setUploadedDocs] = useState([]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await fetchProfile();
        const docs = response.data.kyc_documents || [];

        setUploadedDocs(docs);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    };

    fetchProfileData();
  }, []);

  const handleLogout = async () => {
    const response = await logout();
    if (response.status === "success") {
      removeToken();
      window.location.href = "/";
    } else {
      removeToken();
      window.location.href = "/";
    }
  };

  // useEffect(() => {
  //   if (profileData?.type === "INDIVIDUAL") {
  //     setCurrentStep(1);
  //   }
  // }, [profileData]);

  // fields changes in readOnly if user is Approved and field has value
  const isReadOnly = (value) => {
    return profileData?.status_id === 2 && value;
  };

  // Track the User Stepper Play if User is Approved by Admin
  const handleStepClick = (index) => {
    // Block only visually, NOT logically
    if (profileData?.status_id !== 2) return;

    // If step is hidden for INDIVIDUAL
    if (profileData?.type === "INDIVIDUAL" && index === 0) return;

    setCurrentStep(index);
  };

  const visibleSteps =
    profileData?.type === "INDIVIDUAL"
      ? steps.slice(1).map((s, idx) => ({
          ...s,
          real: idx + 1, // INDIVIDUAL → 1,2,3
        }))
      : steps.map((s, idx) => ({
          ...s,
          real: idx, // BUSINESS → 0,1,2,3
        }));

  const groupedDocuments = documentList.reduce((groups, doc) => {
    const groupName = doc.group || "Other Documents";

    if (!groups[groupName]) {
      groups[groupName] = [];
    }

    groups[groupName].push(doc);
    return groups;
  }, {});

  useEffect(() => {
    const businessName = window.localStorage.getItem("business_name");

    setFormData((prev) => ({
      ...prev,
      businessName: businessName || "",
    }));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-2 px-3">
      {openTypeModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl w-96 shadow-lg">
            <h2 className="text-xl font-semibold mb-4">
              Select Registration Type
            </h2>

            <div className="flex flex-col gap-3">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="userType"
                  value="INDIVIDUAL"
                  onChange={(e) => setUserType(e.target.value)}
                />
                Individual
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="userType"
                  value="BUSINESS"
                  onChange={(e) => setUserType(e.target.value)}
                />
                Business
              </label>

              <div className="w-full flex justify-center">
                <div className="flex border-l-8 border-l-green-700 justify-start items-center gap-3 font-semibold bg-green-100 text-green-800 rounded-xl p-3">
                  <div className="">
                    <strong className="flex items-center gap-2">
                      <User2 /> Select Individual
                    </strong>{" "}
                    if you are registering as a single person using your
                    personal details (no company or firm involved).
                    <br />
                    <br />{" "}
                    <strong className="flex items-center  gap-2">
                      <Building2Icon /> Select Business
                    </strong>{" "}
                    if you are registering on behalf of a company, firm,
                    startup, or organization and will be using business details
                    (GST, company name, etc.).
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={handleUserTypeSelect}
              className="mt-5 w-full bg-blue-600 text-white py-2 rounded-lg"
            >
              Continue
            </button>
          </div>
        </div>
      )}
      {isLoading && <Loader />}

      <DigitalKycAadharSignUp
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        title={`Enter OTP to Verify Aadhar  ****** ${aadhar?.substring(8, 12)}`}
        clientID={clientID}
        setSignatoryData={setSignatoryData}
        onLoadReport={getProfile}
      />
      <DigitalKycEmailSignUp
        isModalOpen={isModalOpenEmail}
        isEmail={true}
        toggleModalEmail={toggleModalEmail}
        emailId={email}
        identifier={identifier}
        onLoadReport={getProfile}
      />
      <DigitalKycMobileSignUp
        isModalOpenMobile={isModalOpenMobile}
        toggleModalMobile={toggleModalMobile}
        onLoadReport={getProfile}
        title={`Enter OTP to Verify Mobile no. ****** ${mobile?.substring(6, 10)}`}
        identifier={identifier}
      />

      <div className="max-w-5xl mx-auto">
        {/* Header */}

        <div className="flex justify-between items-center mb-4">
          {/* Left: Empty spacer for proper centering */}
          <div className="w-1/3"></div>

          {/* Center: Heading */}
          <div className="w-full text-center">
            <h1 className="md:text-2xl text-md font-bold text-gray-800">
              Complete Your Registration{" "}
              {profileData?.type === "INDIVIDUAL"
                ? "(Individual)"
                : "(Business)"}
            </h1>
          </div>

          {/* Right: Logout button */}
          <div className="w-1/2 flex justify-end items-center gap-1">
            {/* Dashboard Button */}
            <Link
              to="/Dashboard"
              className="flex items-center shadow-md hover:bg-slate-300 hover:border-blue-700 
               border-2 cursor-pointer rounded-md p-1 px-2 transition"
            >
              <MdDashboard size={20} className="mr-1 text-blue-900" />
              <span className="text-md font-semibold">GoTo Dashboard</span>
            </Link>

            {/* Logout Button */}
            <div
              onClick={handleLogout}
              className="hidden md:flex items-center shadow-md hover:bg-slate-300 
               hover:border-blue-700 border-2 cursor-pointer rounded-md p-1 px-2 transition"
            >
              <RiLogoutBoxLine size={22} className="mr-1 text-blue-900" />
              <span className="text-md font-semibold">Logout</span>
            </div>
          </div>
        </div>

        {/* Main Container */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden mt-3">
          <div className="flex flex-col lg:flex-row">
            {/* Vertical Stepper - Left Side */}
            <div
              className="bg-gradient-to-b from-blue-600 to-indigo-600 p-3 
                lg:w-80 lg:h-auto 
                w-full flex lg:flex-col flex-row items-center justify-between lg:justify-start overflow-x-auto"
            >
              {/* Heading — hide on mobile */}
              <h2 className="text-white text-xl font-bold mb-4 hidden lg:block">
                Registration Steps
              </h2>

              <div className="flex lg:flex-col flex-row space-y-0 lg:space-y-3 space-x-2 lg:space-x-0 w-full">
                {visibleSteps.map((step) => {
                  const Icon = step.icon;
                  const realIndex = step.real;

                  const isCompleted = realIndex < currentStep;
                  const isCurrent = realIndex === currentStep;

                  return (
                    <div
                      key={step.id}
                      onClick={() => handleStepClick(realIndex)}
                      className={`
          relative flex flex-col lg:flex-none items-center
          ${profileData?.status_id === 2 ? "cursor-pointer" : "cursor-not-allowed opacity-60"}
        `}
                    >
                      <div
                        className={`flex lg:flex-row flex-col items-center lg:p-4 p-2 rounded-lg transition-all duration-300 
            ${isCurrent ? "bg-white bg-opacity-20 shadow-lg" : "hover:bg-white hover:bg-opacity-10"}
          `}
                      >
                        {/* Circle */}
                        <div
                          className={`w-10 h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center transition-all duration-300 
              ${
                isCompleted
                  ? "bg-green-500 shadow-lg"
                  : isCurrent
                    ? "bg-white text-blue-600"
                    : "bg-blue-400 text-white"
              }
            `}
                        >
                          {isCompleted ? (
                            <Check className="w-5 h-5 text-white" />
                          ) : (
                            <Icon className="w-5 h-5" />
                          )}
                        </div>

                        {/* Label */}
                        <div className="ml-2 hidden sm:block text-center lg:text-left">
                          <div
                            className={`text-xs font-medium ${isCurrent ? "text-white font-bold" : "text-blue-100"}`}
                          >
                            Step {realIndex + 1}
                          </div>
                          <div
                            className={`text-xs ${isCurrent ? "text-white font-semibold" : "text-blue-200"}`}
                          >
                            {step.title}
                          </div>
                        </div>
                      </div>

                      {/* Connector */}
                      {realIndex < visibleSteps.length - 1 && (
                        <div className="lg:flex hidden justify-center">
                          <div
                            className={`w-0.5 h-6 transition-all duration-300 ${
                              realIndex < currentStep
                                ? "bg-green-400"
                                : "bg-blue-400"
                            }`}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Progress Indicator — show only on desktop */}
              <div className="mt-2 pt-2 border-t border-blue-400 hidden lg:block">
                <div className="text-blue-100 text-sm mb-2">
                  Overall Progress
                </div>
                <div className="w-full bg-blue-400 rounded-full h-2 mb-2">
                  <div
                    className="bg-green-400 h-2 rounded-full transition-all duration-500"
                    style={{
                      width: `${((currentStep + 1) / steps.length) * 100}%`,
                    }}
                  ></div>
                </div>
                <div className="text-white text-sm font-semibold">
                  {currentStep + 1} of {steps.length} completed
                </div>
              </div>
            </div>

            {/* Form Content - Right Side */}
            <div className="flex-1 p-6 lg:p-6">
              <div className="max-w-2xl">
                {/* Step 0: Business Details */}
                {profileData?.type !== "INDIVIDUAL" && currentStep === 0 && (
                  <div className="space-y-4 animate-fadeIn">
                    <h2 className="text-2xl font-bold text-gray-800 mb-6">
                      Business Details
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="md:col-span-2 flex flex-col md:flex-row md:items-center md:space-x-6">
                        <div className="flex items-center space-x-4 mb-2 md:mb-0">
                          <span className="text-gray-700 font-medium">
                            Do you have GST?{" "}
                            <span className="text-red-500">*</span>
                          </span>

                          {/* Yes Option */}
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              name="gstAvailable"
                              value="yes"
                              checked={formData.gstAvailable === "yes"}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  gstAvailable: e.target.value,
                                }))
                              }
                              className="form-radio text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">Yes</span>
                          </label>

                          {/* No Option */}
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              name="gstAvailable"
                              value="no"
                              checked={formData.gstAvailable === "no"}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  gstAvailable: e.target.value,
                                  gstNo: "",
                                }))
                              }
                              className="form-radio text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">No</span>
                          </label>
                        </div>

                        {/* Conditionally Show GST Number Input */}
                        {formData.gstAvailable === "yes" && (
                          <div className="flex-1">
                            <input
                              type="text"
                              name="gstNo"
                              value={
                                formData.gstNo ||
                                profileData?.company_details?.company_gst_no
                              }
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  gstNo: e.target.value,
                                }))
                              }
                              className={`w-full px-1 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition 
                                                       ${
                                                         (formData.gstNo ??
                                                         profileData
                                                           ?.company_details
                                                           ?.company_gst_no)
                                                           ? "bg-gray-200 cursor-not-allowed border-gray-300"
                                                           : "border-gray-300"
                                                       }`}
                              placeholder="Enter your GST Number"
                              readOnly={isReadOnly(formData.gstNo)}
                              required
                            />
                          </div>
                        )}
                      </div>

                      <div className="">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          CIN/Registration No{" "}
                          <span className="text-red-500">*</span>
                        </label>

                        <div className="flex items-center">
                          <input
                            type="text"
                            name="cinNo"
                            value={
                              cinData?.company_cin ||
                              formData.cinNo ||
                              profileData?.company_details?.company_cin ||
                              ""
                            }
                            onChange={(e) => {
                              handleInputChange(e);
                              const value = e.target.value.trim();
                              if (value.length === 21) handleCinVerify(value);
                            }}
                            className={`w-full px-2 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition 
                             ${
                               profileData?.company_details
                                 ?.company_cin_verified_at
                                 ? "bg-gray-200 cursor-not-allowed"
                                 : ""
                             }`}
                            placeholder="Enter CIN/Registration No"
                            required
                            maxLength={25}
                            readOnly={
                              !!profileData?.company_details
                                ?.company_cin_verified_at
                            }
                          />

                          <button
                            type="button"
                            onClick={() => handleCinVerify(formData.cinNo)}
                            disabled={
                              isLoading ||
                              !!profileData?.company_details
                                ?.company_cin_verified_at ||
                              cinVerifyResponse?.status?.code === 200 ||
                              cinVerifyResponse?.data?.status?.code === 200
                            }
                            className={`px-3 py-1 rounded-lg font-semibold text-white transition ${
                              isLoading ||
                              profileData?.company_details
                                ?.company_cin_verified_at
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-blue-600 hover:bg-blue-700"
                            }`}
                          >
                            {profileData?.company_details
                              ?.company_cin_verified_at ||
                            cinVerifyResponse?.status?.code === 200 ||
                            cinVerifyResponse?.data?.status?.code === 200
                              ? "Verified"
                              : isLoading
                                ? "Verifying..."
                                : "Verify"}
                          </button>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Company PAN <span className="text-red-500">*</span>
                        </label>
                        <div className="flex item-center">
                          <input
                            type="text"
                            name="companyPan"
                            value={
                              formData.companyPan ??
                              profileData?.company_details?.company_pan ??
                              ""
                            }
                            onChange={handleInputChange}
                            className={`w-full px-2 py-1 border rounded-lg 
    ${
      isCompanyPanAlreadyVerified
        ? "bg-gray-200 cursor-not-allowed border-gray-300"
        : isReadOnly(
              formData.companyPan ?? profileData?.company_details?.company_pan,
            )
          ? "bg-gray-200 cursor-not-allowed"
          : "border-gray-300"
    }`}
                            placeholder="Enter Company PAN"
                            disabled={
                              isCompanyPanAlreadyVerified ||
                              isReadOnly(
                                formData.companyPan ??
                                  profileData?.company_details?.company_pan,
                              )
                            }
                            required
                          />

                          <button
                            type="button"
                            className={` px-2 py-1 rounded-lg text-white flex items-center justify-center gap-2 transition
  ${
    isCompanyPanAlreadyVerified || isCompanyPanVerfiy
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-green-500 hover:bg-green-600"
  }`}
                            onClick={validateCompanyPan}
                            disabled={
                              isCompanyPanAlreadyVerified ||
                              isCompanyPanVerfiy ||
                              isLoading
                            }
                          >
                            {isLoading ? (
                              <>
                                <svg
                                  className="w-4 h-4 animate-spin text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <span>Verifying...</span>
                              </>
                            ) : (
                              <>
                                {isCompanyPanAlreadyVerified ||
                                isCompanyPanVerfiy
                                  ? "Verified"
                                  : "Verify"}
                              </>
                            )}
                          </button>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Business Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="businessName"
                          read
                          value={
                            cinData?.company_name
                              ? cinData.company_name
                              : formData.businessName ||
                                profileData?.company_details?.company_name ||
                                ""
                          }
                          onChange={handleInputChange}
                          className={`w-full px-1 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition 
                               ${
                                 (cinData?.company_name ??
                                 profileData?.company_details?.company_name)
                                   ? "bg-gray-200 cursor-not-allowed border-gray-300"
                                   : "border-gray-300"
                               }`}
                          placeholder="Enter Registered Business Name"
                          readOnly={
                            !!cinData?.company_name ||
                            !!profileData?.company_details?.company_name ||
                            formData.businessName
                          }
                          required
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Website URL{" "}
                          <span className="text-gray-400">(optional)</span>
                        </label>

                        <div className="flex">
                          {/* Protocol Select */}
                          <select
                            name="protocol"
                            value={formData.protocol}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                protocol: e.target.value,
                                websiteUrl: `${e.target.value}://${formData.domain}`,
                              })
                            }
                            className="border border-gray-300 rounded-l-lg px-3 py-1 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="https">https://</option>
                            <option value="http">http://</option>
                          </select>

                          {/* Domain Input */}
                          <input
                            type="text"
                            name="domain"
                            value={formData.domain}
                            onChange={(e) => {
                              const domain = e.target.value;
                              setFormData({
                                ...formData,
                                domain,
                                websiteUrl: `${formData.protocol}://${domain}`,
                              });
                            }}
                            className={`w-full px-3 py-1 border rounded-lg 
    ${isReadOnly(formData.domain) ? "bg-gray-200 cursor-not-allowed" : "border-gray-300"}`}
                            readOnly={isReadOnly(formData.domain)}
                            // className="w-full border-t border-b border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="yourbusiness"
                          />
                        </div>

                        {/* Display combined URL */}
                        {formData.websiteUrl && (
                          <p className="text-xs text-gray-600 ">
                            Final URL:{" "}
                            <span className="font-medium">
                              {formData.websiteUrl}
                            </span>
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Business class <span className="text-red-500">*</span>
                        </label>

                        <select
                          name="businessClass"
                          value={
                            formData.businessClass ??
                            profileData?.company_details?.company_type_id ??
                            ""
                          }
                          onChange={handleInputChange}
                          disabled={isReadOnly(
                            formData.businessClass ||
                              profileData?.company_details?.company_type_id,
                          )}
                          className={`w-full px-1 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition 
                              ${
                                (formData.businessClass ??
                                profileData?.company_details?.company_type_id)
                                  ? "bg-gray-200 cursor-not-allowed border-gray-300"
                                  : "border-gray-300"
                              }`}
                          required
                        >
                          <option value="">Select business class</option>

                          {companyTypes.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Line of Business{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="lineOfBusiness"
                          value={formData.lineOfBusiness}
                          onChange={handleInputChange}
                          className={`w-full px-1 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition 
                                                   ${
                                                     (formData.lineOfBusiness ??
                                                     profileData
                                                       ?.company_details
                                                       ?.line_of_business)
                                                       ? "bg-gray-200 cursor-not-allowed border-gray-300"
                                                       : "border-gray-300"
                                                   }`}
                          required
                        >
                          <option className="text-xs" value="">
                            Select Line of your business
                          </option>
                          <option className="text-xs" value="financial_banking">
                            Financial & Banking Services
                          </option>
                          <option className="text-xs" value="it_software">
                            Information Technology (IT) & Software
                          </option>
                          <option className="text-xs" value="ecommerce_retail">
                            E-Commerce & Retail
                          </option>
                          <option
                            className="text-xs"
                            value="manufacturing_industrial"
                          >
                            Manufacturing & Industrial
                          </option>
                          <option className="text-xs" value="marketing_media">
                            Marketing, Advertising & Media
                          </option>
                          <option
                            className="text-xs"
                            value="education_training"
                          >
                            Education & Training
                          </option>
                          <option
                            className="text-xs"
                            value="healthcare_wellness"
                          >
                            Healthcare & Wellness
                          </option>
                          <option
                            className="text-xs"
                            value="realestate_construction"
                          >
                            Real Estate & Construction
                          </option>
                          <option
                            className="text-xs"
                            value="transport_logistics"
                          >
                            Transport, Logistics & Supply Chain
                          </option>
                          <option
                            className="text-xs"
                            value="energy_environment"
                          >
                            Energy & Environment
                          </option>
                          <option className="text-xs" value="business_support">
                            Business Support & Consultancy
                          </option>
                          <option
                            className="text-xs"
                            value="telecom_communication"
                          >
                            Telecom & Communication
                          </option>
                          <option className="text-xs" value="creative_design">
                            Creative & Design Services
                          </option>
                          <option className="text-xs" value="agriculture_rural">
                            Agriculture & Rural Development
                          </option>
                          <option
                            className="text-xs"
                            value="investment_trading"
                          >
                            Investment & Trading
                          </option>
                          <option className="text-xs" value="others">
                            Others
                          </option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Business Description{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <textarea
                          name="businessDescription"
                          value={formData.businessDescription}
                          onChange={handleInputChange}
                          rows="3"
                          className={`w-full px-3 py-2 border rounded-lg transition
                             ${
                               (formData.businessDescription ??
                               profileData?.company_details
                                 ?.business_description)
                                 ? "bg-gray-300 cursor-not-allowed border-gray-300"
                                 : "border-gray-300 focus:ring-2 focus:ring-blue-500"
                             }
                             `}
                          placeholder="What does your business do?"
                          required
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Step 1: Signatory Details */}
                {currentStep === 1 && (
                  <div className="space-y-6 animate-fadeIn">
                    <h2 className="text-2xl font-bold text-gray-800 mb-6">
                      Signatory Details
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {/* Aadhar Number */}
                      <div className="flex flex-col">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Aadhar <span className="text-red-500">*</span>
                        </label>

                        <div className="flex items-center">
                          <input
                            type="text"
                            name="aadharNo"
                            value={formatAadhar(signatoryData.aadharNo)}
                            onChange={handleSignatoryInputChange}
                            className={`flex-1 px-3 py-1 border rounded-lg transition focus:ring-2 focus:ring-blue-500 focus:border-transparent
                            ${isAadharVerify ? "bg-gray-200 cursor-not-allowed border-gray-300" : ""}`}
                            placeholder="Enter Aadhaar Number"
                            disabled={isAadharVerify || isLoading}
                            required
                          />

                          <button
                            type="button"
                            className={`ml-2 px-3 py-1 rounded-lg text-white flex items-center justify-center gap-2 transition
      ${isAadharVerify ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
                            onClick={validateAadhar}
                            disabled={isAadharVerify || isLoading}
                          >
                            {isLoading ? (
                              <>
                                <svg
                                  className="w-4 h-4 animate-spin text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <span>Verifying...</span>
                              </>
                            ) : (
                              <>{isAadharVerify ? "Verified" : "Verify"}</>
                            )}
                          </button>
                        </div>
                      </div>

                      {/* PAN Number */}
                      <div className="flex flex-col">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          PAN <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="text"
                            name="panNo"
                            maxLength={10}
                            value={signatoryData.panNo}
                            onChange={handleSignatoryInputChange}
                            className={`flex-1 px-3 py-1 border uppercase rounded-lg transition focus:ring-2 focus:ring-blue-500 focus:border-transparent
                                ${isPanVerify ? "bg-gray-200 cursor-not-allowed border-gray-300" : ""}`}
                            placeholder="Enter PAN Number"
                            disabled={isPanVerify || isLoading}
                            required
                          />

                          <button
                            type="button"
                            className={`ml-2 px-3 py-1 rounded-lg text-white flex items-center justify-center gap-2 transition
                           ${isPanVerify ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
                            onClick={validatePan}
                            disabled={isPanVerify || isLoading}
                          >
                            {isLoading ? (
                              <>
                                <svg
                                  className="w-4 h-4 animate-spin text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <span>Verifying...</span>
                              </>
                            ) : (
                              <>{isPanVerify ? "Verified" : "Verify"}</>
                            )}
                          </button>
                        </div>
                      </div>

                      {/* Phone Number */}
                      <div className="flex flex-col">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Phone <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="text"
                            name="phone"
                            value={signatoryData.phone}
                            onChange={handleSignatoryInputChange}
                            className={`flex-1 px-3 py-1 border rounded-lg transition focus:ring-2 focus:ring-blue-500 focus:border-transparent
      ${mobileVerified ? "bg-gray-200 cursor-not-allowed border-gray-300" : ""}`}
                            placeholder="+91 9876543210"
                            disabled={mobileVerified || isLoading}
                          />

                          <button
                            type="button"
                            className={`ml-2 px-3 py-1 rounded-lg text-white flex items-center justify-center gap-2 transition
      ${mobileVerified ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
                            onClick={validateMobile}
                            disabled={mobileVerified || isLoading}
                          >
                            {isLoading ? (
                              <>
                                <svg
                                  className="w-4 h-4 animate-spin text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <span>Verifying...</span>
                              </>
                            ) : (
                              <>{mobileVerified ? "Verified" : "Verify"}</>
                            )}
                          </button>
                        </div>
                      </div>
                      {/* isEmailVerify */}

                      {/* Email */}
                      <div className="flex flex-col">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Email <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="email"
                            name="email"
                            value={signatoryData.email}
                            onChange={handleSignatoryInputChange}
                            className={`flex-1 px-3 py-1 border rounded-lg transition focus:ring-2 focus:ring-blue-500 focus:border-transparent
      ${isEmailVerify ? "bg-gray-200 cursor-not-allowed border-gray-300" : ""}`}
                            placeholder="Enter Email"
                            disabled={isEmailVerify || isLoading}
                          />

                          <button
                            type="button"
                            className={`ml-2 px-3 py-1 rounded-lg text-white flex items-center justify-center gap-2 transition
      ${isEmailVerify ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
                            onClick={validateEmail}
                            disabled={isEmailVerify || isLoading}
                          >
                            {isLoading ? (
                              <>
                                <svg
                                  className="w-4 h-4 animate-spin text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <span>Verifying...</span>
                              </>
                            ) : (
                              <>{isEmailVerify ? "Verified" : "Verify"}</>
                            )}
                          </button>
                        </div>
                      </div>

                      {/* Enter Name  */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Name on Aadhar <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center">
                          <input
                            type="text"
                            name="name"
                            value={signatoryData?.name || panData?.name || ""}
                            onChange={handleSignatoryInputChange}
                            className={`flex-1 px-3 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition
        ${
          signatoryData?.name
            ? "bg-gray-200 cursor-not-allowed border-gray-300"
            : "border-gray-300"
        }`}
                            placeholder="Enter Name as per Aadhar"
                            readOnly={!!signatoryData?.name} //  make read-only if value exists
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col mt-3">
                      <span>
                        <b>Name:</b> {signatoryData?.name || "-"}
                      </span>
                      <span>
                        <b>DOB:</b> {signatoryData?.dob || "-"}
                      </span>
                      <span>
                        <b>Address:</b>{" "}
                        {signatoryData?.aadhar_response?.address
                          ? `${signatoryData.aadhar_response.address.house}, ${signatoryData.aadhar_response.address.street}, ${signatoryData.aadhar_response.address.loc}, ${signatoryData.aadhar_response.address.landmark}, ${signatoryData.aadhar_response.address.vtc}, ${signatoryData.aadhar_response.address.subdist}, ${signatoryData.aadhar_response.address.dist}, ${signatoryData.aadhar_response.address.state}, ${signatoryData.aadhar_response.address.country}`
                          : signatoryData.landmarkAddress || "-"}
                      </span>
                    </div>
                  </div>
                )}

                {/* Upload Document Steps */}
                {currentStep === 2 && (
                  <div className="space-y-1 animate-fadeIn">
                    <h3 className="text-2xl font-bold text-gray-800">
                      Upload Documents
                    </h3>

                    {/* 🔹 GROUP GRID (2 groups per row) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      {Object.entries(groupedDocuments).map(
                        ([groupName, docs]) => (
                          <div
                            key={groupName}
                            className="border-2 border-blue-600 rounded-lg space-y-1 bg-white"
                          >
                            {/* Group Heading */}
                            <h3 className="text-sm font-semibold px-2 text-white bg-blue-800 rounded-md border-b pb-1">
                              {groupName}
                            </h3>

                            {/* 🔹 DOCUMENT GRID INSIDE GROUP */}
                            <div
                              className={`grid gap-1 p-1 text-xs ${
                                docs.length > 1
                                  ? "grid-cols-2 md:grid-cols-2"
                                  : "grid-cols-2"
                              }`}
                            >
                              {docs.map((doc) => {
                                const uploadedDoc = uploadedDocs.find(
                                  (d) => d.document_id === doc.id,
                                );

                                return (
                                  <div
                                    key={doc.id}
                                    className={`relative border rounded-md p-1 transition
                    ${
                      uploadedDoc
                        ? "border-green-500 bg-green-50"
                        : "border-gray-300"
                    }`}
                                  >
                                    {/* Uploaded Tick */}
                                    {uploadedDoc && (
                                      <span className="absolute top-1 right-1 text-green-600 text-lg font-bold">
                                        ✓
                                      </span>
                                    )}

                                    {/* Required Badge */}
                                    {doc.is_required && (
                                      <span className="absolute top-1 left-1 bg-red-500 text-white text-[8px] px-1 rounded">
                                        REQUIRED
                                      </span>
                                    )}

                                    <FileUploadBox
                                      label={doc.name}
                                      description={doc.kyc_applicable}
                                      name={doc.name}
                                      accept=".pdf,.jpg,.jpeg,.png"
                                      handleInputChange={
                                        handleDocumentInputChange
                                      }
                                      uploadedFile={DoctformData[doc.name]}
                                      // disabled={!!uploadedDoc}
                                    />

                                    {uploadedDoc && (
                                      <p className="text-green-700 text-[10px] mt-1">
                                        Uploaded on{" "}
                                        {new Date(
                                          uploadedDoc.created_at,
                                        ).toLocaleString()}
                                      </p>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                )}

                {/* Step 3: Final Submission & Summary */}
                {currentStep === 3 && finalDetails && (
                  <div className="max-w-lg mx-auto mt-6 p-4 bg-gradient-to-br from-green-100 to-green-50 rounded-xl shadow-2xl animate-fadeIn border border-green-300">
                    <div className="text-center space-y-3">
                      <h2 className="text-3xl font-extrabold text-green-800">
                        🎉 Registration Completed!
                      </h2>
                      <p className="text-green-700 text-lg">
                        User registered Successfully. Below are the details:
                      </p>
                    </div>

                    {/* User Details */}
                    <div className="bg-white rounded-lg shadow-inner p-4 mt-4 space-y-2 border border-green-200">
                      <p>
                        <span className="font-semibold text-green-800">
                          User ID:
                        </span>{" "}
                        <span className="text-gray-700">
                          {finalDetails?.user_id || profileData?.user_id || ""}
                        </span>
                      </p>
                      <p>
                        <span className="font-semibold text-green-800">
                          Pin :{" "}
                        </span>{" "}
                        <span className="text-gray-700 font-bold">
                          {(() => {
                            const mobile =
                              finalDetails?.mobile_number ||
                              profileData?.mobile_number ||
                              "";
                            return mobile.length >= 6 ? mobile.slice(-6) : "";
                          })()}
                        </span>
                      </p>

                      <p>
                        <span className="font-semibold text-green-800">
                          Name:
                        </span>{" "}
                        <span className="text-gray-700">
                          {finalDetails?.name || profileData?.name || ""}
                        </span>
                      </p>
                      <p>
                        <span className="font-semibold text-green-800">
                          Mobile:
                        </span>{" "}
                        <span className="text-gray-700">
                          {finalDetails?.mobile_number ||
                            profileData?.mobile_number ||
                            ""}
                        </span>
                      </p>
                      <p>
                        <span className="font-semibold text-green-800">
                          Email:
                        </span>{" "}
                        <span className="text-gray-700">
                          {finalDetails?.email_address ||
                            profileData?.email_address ||
                            ""}
                        </span>
                      </p>
                      <p>
                        <span className="font-semibold text-green-800">
                          Aadhaar:
                        </span>{" "}
                        <span className="text-gray-700">
                          {finalDetails?.aadhar_number ||
                            profileData?.aadhar_number ||
                            ""}
                        </span>
                      </p>
                      <p>
                        <span className="font-semibold text-green-800">
                          PAN:
                        </span>{" "}
                        <span className="text-gray-700">
                          {finalDetails?.pan_number ||
                            profileData?.pan_number ||
                            ""}
                        </span>
                      </p>
                    </div>

                    {/* Success message */}
                    <div className="flex justify-center items-center gap-3 mt-2 bg-green-50 p-3 rounded-lg border border-green-200 shadow-sm">
                      <CheckCircle className="text-green-600 w-8 h-8" />
                      <span className="text-green-700 font-semibold text-lg">
                        All steps completed successfully!
                      </span>
                    </div>
                    <p className="text-sm italic text-green-700 mt-1 text-center">
                      Your PIN is the last 6 digits of your registered mobile
                      number.
                    </p>
                  </div>
                )}

                <div className="flex justify-between mt-2 pt-2 border-t border-gray-200">
                  {/* Previous */}
                  <button
                    type="button"
                    onClick={handlePrev}
                    disabled={currentStep === 0}
                    className={`px-2 py-1 rounded-lg font-medium transition ${
                      currentStep === 0
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                    }`}
                  >
                    Previous
                  </button>

                  {/* Next or Submit */}
                  {currentStep < steps.length - 1 ? (
                    <button
                      type="button"
                      onClick={handleNext}
                      className="px-2 py-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition shadow-lg hover:shadow-xl"
                    >
                      Submit & Next
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="px-1 py-1 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg font-medium hover:from-green-700 hover:to-green-800 transition shadow-lg hover:shadow-xl"
                    >
                      Submit Registration
                    </button>
                  )}
                </div>

                <div className="flex mt-10 flex-col justify-start items-start gap-2">
                  <div className="w-full mt-10 flex justify-start">
                    <div className="flex border-l-8 border-l-red-700 justify-start items-center gap-3 font-semibold bg-red-100 text-red-800 rounded-xl p-3">
                      <ShieldAlert className="" />
                      <div className="">
                        Please Don't upload Password Protected Documents, It may
                        cause rejection.
                      </div>
                    </div>
                  </div>

                  <div className="w-full  flex justify-start">
                    <div className="flex border-l-8 border-l-green-700 justify-start items-center gap-3 font-semibold bg-green-100 text-green-800 rounded-xl p-3">
                      <div className="">
                        Your KYC information is सुरक्षित and handled with strict
                        confidentiality. We are compliant with applicable data
                        protection laws, including DPDP guidelines.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
      <ToastContainer />
    </div>
  );
}
